import { useAuth0 } from '@auth0/auth0-react';
import { useQuery } from '@tanstack/react-query';
import { getAtlasFeatures } from '../api/get-atlas-features';
import { AtlasGetFeaturesResponse } from '../types';

export const useAtlasFeatures = () => {
  const { isAuthenticated } = useAuth0();

  return useQuery<AtlasGetFeaturesResponse[], Error>(['AtlasFeatures'], getAtlasFeatures, {
    staleTime: Infinity,
    cacheTime: Infinity,
    enabled: isAuthenticated,
  });
};
